import { render } from "./BatchFormContainer.vue?vue&type=template&id=5ef3d21d"
import script from "./BatchFormContainer.vue?vue&type=script&lang=js"
export * from "./BatchFormContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__